// extracted by mini-css-extract-plugin
export default {"listItem":"_2wsAOOKTdDOJ8AKlESE7TU","link":"_33KbJ7TAtRUJnkjSQcRyCN"};